import type { ImageUrl } from "@@/shared/images/image-url";
import { imageUrlZodType } from "@@/shared/images/image-url";
import { z } from "zod";
import type { MetaImage } from "../meta-content/meta-image";
import { metaImageZodSchema } from "../meta-content/meta-image";
import type { StorageItemImage } from "../storage-items/storage-item-images/storage-item-image";
import { storageItemImageZodSchema } from "../storage-items/storage-item-images/storage-item-image";
import type { StorageItemImageId } from "../storage-items/storage-item-images/storage-item-image-id";
import { storageItemImageIdZodSchema } from "../storage-items/storage-item-images/storage-item-image-id";
import type { StorageItemImageReference } from "../storage-items/storage-item-images/storage-item-image-reference";
import { storageItemImageReferenceZodSchema } from "../storage-items/storage-item-images/storage-item-image-reference";
import type { StorageItemImageReferenceId } from "../storage-items/storage-item-images/storage-item-image-reference-id";
import { storageItemImageReferenceIdZodSchema } from "../storage-items/storage-item-images/storage-item-image-reference-id";
import type { ImageReference } from "./image-reference";
import { imageReferenceZodSchema } from "./image-reference";
import type { ImageReferenceId } from "./image-reference-id";
import { imageReferenceIdZodSchema } from "./image-reference-id";

type ImageRef =
    | ImageReference
    | StorageItemImageId
    | StorageItemImageReference
    | StorageItemImage
    | MetaImage
    | ImageUrl;

type ImageRefId =
    | ImageReferenceId
    | StorageItemImageReferenceId
    | StorageItemImageId;

const imageRefZodSchema: z.ZodSchema<ImageRef> = z.union([
    imageReferenceZodSchema,
    storageItemImageReferenceZodSchema,
    storageItemImageZodSchema,
    metaImageZodSchema,
    imageUrlZodType,
    storageItemImageIdZodSchema,
]);

const imageRefWithoutStorageItemImageIdZodUnion: z.ZodSchema<
    Exclude<ImageRef, StorageItemImageId>
> = z.union([
    imageReferenceZodSchema,
    storageItemImageReferenceZodSchema,
    storageItemImageZodSchema,
    metaImageZodSchema,
    imageUrlZodType,
]);

const imageRefIdZodSchema: z.ZodSchema<ImageRefId> = z.union([
    imageReferenceIdZodSchema,
    storageItemImageIdZodSchema,
    storageItemImageReferenceIdZodSchema,
]);

export {
    imageRefIdZodSchema,
    imageRefWithoutStorageItemImageIdZodUnion,
    imageRefZodSchema,
};
export type { ImageRef, ImageRefId };
